import { render } from "./Main.vue?vue&type=template&id=5fd04fee"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Main.vue?vue&type=style&index=0&id=5fd04fee&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__